<template>
  <div class="page-header-index-wide">
    <a-row :gutter="24">
      <a-col :sm="24" :md="12" :xl="8" :style="{ marginBottom: '24px' }">
        <chart-card :loading="loading.sum" title="终端总数量" :total="deviceNum | NumberFormat">
          <a-tooltip title="指标说明" slot="action">
            <a-icon type="info-circle-o" />
          </a-tooltip>
          <div>
            <mini-area />
          </div>
          <template slot="footer">当前轮询间隔<span> {{ interval | NumberFormat }} 秒</span></template>
        </chart-card>
      </a-col>
      <a-col :sm="24" :md="12" :xl="8" :style="{ marginBottom: '24px' }">
        <chart-card :loading="loading.growth" title="本月终端增量" :total="barChart.thisMonth | NumberFormat">
          <a-tooltip title="指标说明" slot="action">
            <a-icon type="info-circle-o" />
          </a-tooltip>
          <div>
            <mini-bar :dataList="barChart.dataList"/>
          </div>
          <template slot="footer">
            <trend flag="up">
              <span slot="term">月环比</span>
              {{ growthRate }}
            </trend>
          </template>
        </chart-card>
      </a-col>
      <a-col :sm="24" :md="12" :xl="8" :style="{ marginBottom: '24px' }">
        <chart-card :loading="loading.growth" title="存储占用率" total="78%">
          <a-tooltip title="指标说明" slot="action">
            <a-icon type="info-circle-o" />
          </a-tooltip>
          <div>
            <mini-progress color="rgb(19, 194, 194)" :target="80" :percentage="78" height="8px" />
          </div>
          <template slot="footer">
            剩余空间 <span style="color:#faad14">218GB</span>
          </template>
        </chart-card>
      </a-col>
    </a-row>

    <a-card :bordered="false" :body-style="{padding: '0'}">
      <div class="salesCard">
        <a-tabs default-active-key="1" size="large" :tab-bar-style="{marginBottom: '24px', paddingLeft: '16px'}">
          <a-tab-pane loading="true" tab="主要" key="1">
            <a-row>
              <a-col :xl="16" :lg="12" :md="12" :sm="24" :xs="24">
                <a-spin :spinning="loading.upgrade">
                  <bar title="终端升级统计" :dataList="recordBar"/>
                </a-spin>
              </a-col>
              <a-col :xl="8" :lg="12" :md="12" :sm="24" :xs="24">
                <a-spin :spinning="loading.rank">
                  <rank-list title="客户终端数量排行" :list="rankList"/>
                </a-spin>
              </a-col>
            </a-row>
          </a-tab-pane>
        </a-tabs>
      </div>
    </a-card>
  </div>
</template>

<script>
import moment from 'moment'
import { ChartCard, MiniArea, MiniBar, MiniProgress, RankList, Bar, Trend, NumberInfo, MiniSmoothArea } from '@/components'
import { mixinDevice } from '@/utils/mixin'
import { countDevice, getGrowthBarChart, getTop10CorpsCount, getPollingInterval } from '@/api/device'
import { getMonthlyUpgradeData } from '@/api/device-upgrade-record'

const searchUserData = []
for (let i = 0; i < 7; i++) {
  searchUserData.push({
    x: moment().add(i, 'days').format('YYYY-MM-DD'),
    y: Math.ceil(Math.random() * 10)
  })
}
const searchUserScale = [
  {
    dataKey: 'x',
    alias: '时间'
  },
  {
    dataKey: 'y',
    alias: '用户数',
    min: 0,
    max: 10
  }]

export default {
  mixins: [mixinDevice],
  components: {
    ChartCard,
    MiniArea,
    MiniBar,
    MiniProgress,
    RankList,
    Bar,
    Trend,
    NumberInfo,
    MiniSmoothArea
  },
  data () {
    return {
      loading: {
        sum: false,
        growth: false,
        upgrade: false,
        rank: false
      },
      // 搜索用户数
      searchUserData,
      searchUserScale,
      deviceNum: 0,
      interval: 10,
      barChart: {},
      recordBar: [],
      rankList: []
    }
  },
  computed: {
    growthRate () {
      let rate
      if (this.barChart) {
        if (this.barChart.lastMonth === 0) {
          rate = this.barChart.thisMonth === 0 ? 0 : 100
        } else {
          rate = (1 - this.barChart.thisMonth / this.barChart.lastMonth) * 100
        }
      } else {
        rate = 0
      }
      return rate + '%'
    }
  },
  created () {
    this.loadData()
  },
  methods: {
    loadData () {
      this.loading.sum = true
      this.loading.growth = true
      this.loading.upgrade = true
      this.loading.rank = true
      countDevice().then(response => {
        this.deviceNum = response.data
      }).catch(err => {
        console.log(err)
      }).finally(() => {
        this.loading.sum = false
      })
      getPollingInterval().then(response => {
        this.interval = response.data
      }).catch(err => {
        console.log(err)
      }).finally(() => {
        this.loading.sum = false
      })
      getGrowthBarChart().then(response => {
        this.barChart = response.data
      }).catch(err => {
        console.log(err)
      }).finally(() => {
        this.loading.growth = false
      })
      getMonthlyUpgradeData().then(response => {
        this.recordBar = response.data
      }).catch(err => {
        console.log(err)
      }).finally(() => {
        this.loading.upgrade = false
      })
      getTop10CorpsCount().then(response => {
        this.rankList = response.data
      }).catch(err => {
        console.log(err)
      }).finally(() => {
        this.loading.rank = false
      })
    }
  }
}
</script>

<style lang="less" scoped>
  .antd-pro-pages-dashboard-analysis-twoColLayout {
    position: relative;
    display: flex;
    display: block;
    flex-flow: row wrap;

    &.desktop div[class^=ant-col]:last-child {
      position: absolute;
      right: 0;
      height: 100%;
    }
  }

  .antd-pro-pages-dashboard-analysis-salesCard {
    height: calc(100% - 24px);
    /deep/ .ant-card-head {
      position: relative;
    }
  }

  .dashboard-analysis-iconGroup {
    i {
      margin-left: 16px;
      color: rgba(0,0,0,.45);
      cursor: pointer;
      transition: color .32s;
      color: black;
    }
  }
  .analysis-salesTypeRadio {
    position: absolute;
    right: 54px;
    bottom: 12px;
  }
</style>
